import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";
import { makeStyles } from "@material-ui/core/styles";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import useAuth from "hooks/useAuth"
import Edit from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
const useStyles2 = makeStyles(styles2);


function ModalUpdateClientZone(props) {
  const classes2 = useStyles2();
  const { storageId, storageUserType } = useAuth();

  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);
  const [idZone, setIdZone] = useState(null);
  const [zones, setZones] = useState([]);
  const [idRegion, setIdRegion] = useState(null);
  const [regions, setRegions] = useState([]);
  const [edit, setEdit] = useState(true);
  useEffect(() => {
    getRegions();
  }, []);
  useEffect(() => {
    if (idRegion) {
      getZones();
    };
  }, [idRegion]);
  useEffect(() => {
    if (controlSnack) {
      showNotification("br")
    }
  }, [controlSnack]);
  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
            props.onHide();
          }, 1500);
        }
        break;
      default:
        break;
    }
  };
  const alterEdit = () => {
    setEdit(!edit);
  };

  async function getRegions() {
    try {
      const response = await api.get(`/region/${storageId}?type=${storageUserType}&search=`);
      if (response.status === 200) {
        if (response.data.regions.length > 0) {
          setRegions(response.data.regions);
          setIdRegion(response.data.regions[0].id);
        } else {
          setRegions([]);
          setIdRegion(null);
        }
      }
    } catch (error) {

    };
  };
  async function getZones() {
    try {
      const response = await api.get(`/zone/${storageId}?type=${storageUserType}&region=${idRegion}&search=`);
      if (response.status === 200) {
        if (response.data.zones.length > 0) {
          setZones(response.data.zones);
          setIdZone(response.data.zones[0].id);
        } else {
          setZones([]);
          setIdZone(null)
        }
      }
    } catch (error) {

    };
  };
  async function handleUpdateZone(e) {
    e.preventDefault();
    if (!idZone) return alert('selecione uma zona');
    const response = await api.patch(`/client/add/zone/${props.props.id}/${idZone}`, {
    });
    if (response.status === 200) {
      setControlSnack(true);
      props.getAllClients();
    } else {
      alert('Erro ao vincular zona a cliente');
    }
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar Zona do Cliente

        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleUpdateZone}>
        <Modal.Body>
          <Form.Row style={{ textAlign: 'center' }}>
            <Form.Group as={Col} xs={1} controlId="formGridName">
              <Form.Label></Form.Label>
              <div style={{ marginTop: '1em' }}>
                <Tooltip id="tooltip-top" title="Editar" placement="top" classes={{ tooltip: classes2.tooltip }} >
                  <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => alterEdit()} >
                    <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                  </IconButton>
                </Tooltip>
              </div>
            </Form.Group>
            <Form.Group as={Col} xs={3} controlId="formGridName">
              <Form.Label>REGIÃO</Form.Label>
              <Form.Control onChange={event => setIdRegion(event.target.value)} value={idRegion} as="select" defaultValue="Choose..." disabled={edit}>
                {regions.map(region => (
                  <option key={String(region.id)} value={region.id}>{`${region.code} - ${region.name}`}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} xs={3} controlId="formGridName">
              <Form.Label>ZONA</Form.Label>
              <Form.Control onChange={event => setIdZone(event.target.value)} value={idZone} as="select" defaultValue="Choose..." disabled={edit}>
                {zones.map(zone => (
                  <option key={String(zone.id)} value={zone.id}>{`${zone.code} - ${zone.name}`}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} xs={3} controlId="formGridName">
              <Form.Label>ZONA ATUAL DO CLIENTE</Form.Label>
              <div style={{ opacity: 1 }}>
                <p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{props.props.zone_name ? props.props.zone_name : 'Sem zona'}</p>
              </div>
            </Form.Group>
          </Form.Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit" disabled={edit}>
              Salvar
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message={`zona vinculada com sucesso`}
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalUpdateClientZone;